import { storeSettings, catalogCollectedData, panelModes } from "@/mocks/panelContent";
import { FieldRow, LockedButton, PanelBadge, PanelCard, ReadOnlyNotice } from "../components/PanelUI";

export default function SettingsSection() {
  return (
    <div className="flex flex-col gap-6">
      <ReadOnlyNotice text={panelModes.viewNotice} />

      <PanelCard
        title="Configurações da loja"
        description="Informações institucionais e textos de apoio."
        action={<PanelBadge tone="primary">Amora Belle</PanelBadge>}
      >
        <div className="grid grid-cols-1 gap-x-8 lg:grid-cols-2">
          <div className="rounded-md border border-background-200 bg-background-100 px-3 py-1">
            <FieldRow label="Nome da loja" value={storeSettings.name} />
            <FieldRow label="Slogan" value={storeSettings.slogan} />
            <FieldRow label="Telefone" value={storeSettings.phone} />
            <FieldRow label="WhatsApp" value={storeSettings.whatsapp} />
            <FieldRow label="Instagram" value={storeSettings.instagram} />
            <FieldRow label="Localização" value={storeSettings.address} />
          </div>
          <div className="rounded-md border border-background-200 bg-background-100 px-3 py-1">
            <FieldRow label="Horários" value={storeSettings.hours} />
            <FieldRow label="Texto institucional" value={storeSettings.institutionalText} />
            <FieldRow label="Política de privacidade" value={storeSettings.privacyPolicy} />
            <FieldRow label="Política de troca" value={storeSettings.exchangePolicy} />
          </div>
        </div>
        <div className="mt-4">
          <LockedButton icon="ri-edit-2-line" hint="Alterações apenas pela administração Vellora">
            Editar configurações
          </LockedButton>
        </div>
      </PanelCard>

      <PanelCard
        title="Dados coletados no checkout"
        description="Campos solicitados na finalização da sacola."
      >
        <ul className="flex flex-wrap gap-2">
          {catalogCollectedData.map((item) => (
            <li key={item} className="rounded-md border border-background-200 bg-background-100 px-3 py-1.5 text-xs text-foreground-700">
              {item}
            </li>
          ))}
        </ul>
      </PanelCard>

      <PanelCard title="Integrações e indexação">
        <div className="rounded-md border border-background-200 bg-background-100 px-3 py-1">
          <FieldRow label="WhatsApp" value="Ativo (atendimento e pedidos)" />
          <FieldRow label="Instagram" value="Ativo" />
          <FieldRow label="Site Vellora Studio" value="Ativo" />
          <FieldRow label="Indexação" value="index, follow" />
        </div>
        <p className="mt-3 text-[11px] leading-relaxed text-foreground-500">
          A indexação permanece habilitada, pois a página é utilizada em anúncios. Contatos,
          integrações e configurações globais não são alterados sem confirmação.
        </p>
      </PanelCard>
    </div>
  );
}